import React, { useState, useEffect } from 'react';
import { login } from '../services/auth';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);
  const [dark, setDark] = useState(() => localStorage.getItem('theme') === 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
    localStorage.setItem('theme', dark ? 'dark' : 'light');
  }, [dark]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) { setError('Please enter username and password'); return; }
    setLoading(true);
    setError('');
    try {
      await login(username, password);
      window.location.href = '/';
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg-primary)', transition: 'background 0.2s',
    }}>
      <div style={{ textAlign: 'center', maxWidth: 400, width: '100%', padding: '0 16px' }}>
        {/* Theme toggle */}
        <div style={{ position: 'fixed', top: 16, right: 16 }}>
          <button
            onClick={() => setDark(!dark)}
            style={{
              background: 'var(--bg-card)', border: '1px solid var(--border-color)',
              borderRadius: 8, padding: '8px 12px', cursor: 'pointer', fontSize: 18,
              boxShadow: 'var(--shadow)',
            }}
            title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
          >{dark ? '☀️' : '🌙'}</button>
        </div>

        {/* Logo */}
        <div style={{
          width: 72, height: 72, borderRadius: 16, background: 'var(--accent)',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16,
          fontSize: 36, boxShadow: '0 4px 16px rgba(24,119,242,0.3)',
        }}>💧</div>
        <h1 style={{ fontSize: 28, fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 4px' }}>Loboc Municipal</h1>
        <h2 style={{ fontSize: 18, fontWeight: 500, color: 'var(--text-secondary)', margin: '0 0 24px' }}>Waterworks</h2>

        {/* Login card */}
        <div style={{
          background: 'var(--bg-card)', borderRadius: 8, padding: '24px 20px',
          border: '1px solid var(--border-color)', boxShadow: 'var(--shadow-lg)',
          transition: 'background 0.2s, border-color 0.2s',
        }}>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 12 }}>
              <input
                type="text" value={username} onChange={e => setUsername(e.target.value)}
                placeholder="Username" autoFocus
                style={{
                  width: '100%', padding: '14px 16px', borderRadius: 6, border: '1px solid var(--border-color)',
                  fontSize: 16, boxSizing: 'border-box', background: 'var(--bg-input)', color: 'var(--text-primary)',
                  transition: 'background 0.2s, border-color 0.2s',
                }}
              />
            </div>
            <div style={{ marginBottom: 12 }}>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPw ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="Password"
                  style={{
                    width: '100%', padding: '14px 44px 14px 16px', borderRadius: 6, border: '1px solid var(--border-color)',
                    fontSize: 16, boxSizing: 'border-box', background: 'var(--bg-input)', color: 'var(--text-primary)',
                    transition: 'background 0.2s, border-color 0.2s',
                  }}
                />
                <button type="button" onClick={() => setShowPw(!showPw)} style={{
                  position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
                  border: 'none', background: 'none', cursor: 'pointer', fontSize: 18, color: 'var(--text-secondary)',
                }}>{showPw ? '🙈' : '👁️'}</button>
              </div>
            </div>

            {error && (
              <div style={{
                background: 'var(--danger-bg)', border: '1px solid var(--danger)', borderRadius: 6, padding: '10px 12px',
                color: 'var(--danger)', fontSize: 14, marginBottom: 12, textAlign: 'left', fontWeight: 500,
              }}>⚠️ {error}</div>
            )}

            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '12px', borderRadius: 6, border: 'none',
              background: 'var(--accent)', color: '#fff', fontSize: 17, fontWeight: 700,
              cursor: loading ? 'wait' : 'pointer', opacity: loading ? 0.7 : 1,
              transition: 'background 0.15s',
            }}>
              {loading ? 'Signing in...' : 'Log In'}
            </button>
          </form>
          <div style={{ borderTop: '1px solid var(--border-color)', marginTop: 20, paddingTop: 16, textAlign: 'center' }}>
            <span style={{ color: 'var(--text-secondary)', fontSize: 13 }}>Loboc Municipal Waterworks</span>
          </div>
        </div>
      </div>
    </div>
  );
}
